import * as $ from "jquery";
import { stringStartsWith } from "./Vgr.Util";
export namespace FotowebIntegration {

    //var _vgr = (window as any).Vgr;

    // Polyfill for Array.prototype.find
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, 'find', {
            value: function (predicate) {
                // 1. Let O be ? ToObject(this value).
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If IsCallable(predicate) is false, throw a TypeError exception.
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }

                // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
                var thisArg = arguments[1];

                // 5. Let k be 0.
                var k = 0;

                // 6. Repeat, while k < len
                while (k < len) {
                    // a. Let Pk be ! ToString(k).
                    // b. Let kValue be ? Get(O, Pk).
                    // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                    // d. If testResult is true, return kValue.
                    var kValue = o[k];
                    if (predicate.call(thisArg, kValue, k, o)) {
                        return kValue;
                    }
                    // e. Increase k by 1.
                    k++;
                }

                // 7. Return undefined.
                return undefined;
            }
        });
    }

    interface ICurrentContext {
        dataType: string;
        id: string;
        language: string;
        name: string;
        parentLink: string;
    }

    interface IFotowebImageMetadata {
        alttext: string;
        description: string;
        showDescription: boolean;
        photographer: string;
        showPhotographer: boolean;
        cropData: string;
        uniqeid: string;
    }

    interface ICropRectangle {
        x1: number;
        y1: number;
        x2: number;
        y2: number;
        cropBoxData?: string;
    }

    class AjaxResponse {
        constructor(init?: Partial<AjaxResponse>) {
            Object.assign(this, init);
        }

        responseData: any;
        statusCode: number;
        status: string;
        error: string;
        xhr: $;
    }

    class FwApiService {
        static instance: FwApiService;
        token: any;
        queue: Object;

        constructor() {
            this.queue = {};
        }

        // Singleton pattern
        static getInstance(): FwApiService {
            if (!FwApiService.instance) {
                FwApiService.instance = new FwApiService();
            }

            return FwApiService.instance;
        }

        subscribe(event: string, callback: Function) {
            // Create the event's object if not yet created
            if (this.queue[event] === undefined) this.queue[event] = [];

            // Add the callback to queue
            let index = this.queue[event].push(callback) - 1;
        }

        fire(event: string, response: any) {

            // If the event doesn't exist, or there are no callbacks in queue, just leave
            if (this.queue[event] === undefined) return;

            // Cycle through queue, fire!
            this.queue[event].forEach(callback => {
                callback(response != undefined ? response : {});
            });
        }

        getUserToken = (callback: Function) => {

            // Om det redan finns en token kan vi anropa callbacken på en gång
            if (this.token) {
                callback(this.token);
                return;
            }

            var event = 'GetUserToken';
            // Skapar en kö med callbacks som ska anropas efter vi har fått tillbaka svaret från API:et.
            // Kön behövs eftersom en sida kan innehålla flera Fotoweb egenskaper och alla instansieras när sidan laddas.
            // Bara den första i kön ska anropa API:et, sedan ska svaret skickas tillbaka till alla andra instanser av egenskapen.
            this.subscribe(event, callback);

            // Call the Fotoweb API only for the first object
            if (this.queue[event].length == 1) {
                const getCookieValue = (name) => (
                    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
                )

                const cookie = getCookieValue("mediebank_access_token");

                this.token = cookie;

                this.fire(event, cookie);
                // Remove the queue
                delete this.queue[event];
            }
        }

        getArchives = (callback: Function) => {
            if (!this.token) return null;

            var event = 'GetArchives';
            this.subscribe(event, callback);

            if (this.queue[event].length == 1) {
                $.get('/fotowebAPI/GetArchives', { usertoken: this.token }, response => {
                    this.fire(event, response);

                    delete this.queue[event];
                });
            }
        }

        getAlbums = (callback: Function) => {
            if (!this.token) return null;

            $.get('/fotowebAPI/GetAlbums', { usertoken: this.token }, response => {
                callback(response);
            });
        }

        getBookMarks = (callback: Function) => {
            if(!this.token) return null;

            $.get('/fotowebAPI/GetBookmarks', { usertoken: this.token }, response => {
                callback(response);
            });
        }

        search = (searchTerm: string, callback: Function) => {
            if (!this.token) return null;

            $.get('/fotowebAPI/Search', { searchString: searchTerm, usertoken: this.token }, response => {
                callback(response);
            });
        }

        getSingleAsset = (assetInfoHref: string, callback: Function) => {
            if (!this.token) return null;

            $.ajax({
                url: '/fotowebAPI/GetSingleAsset',
                data: { assetInfoHref: assetInfoHref, usertoken: this.token },
                statusCode: {
                    404: () => {
                        callback(new AjaxResponse({ responseData: null, statusCode: 404 }));
                    }
                },
                success: (responseAsset) => {
                    callback(new AjaxResponse({ responseData: responseAsset, statusCode: 200 }));
                },
                error: (e) => {
                    //console.log('An unhandled error occured, see the error object for more details:');
                    //console.log(e);
                }
            });
        }

        getArchiveAssetList = (nextPage: string, archiveData: string, callback: Function) => {
            if (!this.token) return null;

            $.get('/fotowebAPI/GetArchiveAssetList', { archivedata: nextPage === undefined ? archiveData : nextPage, usertoken: this.token }, data => {
                callback(data);
            });
        }

        requestFullAsset = (href: string, callback: Function) => {
            if (!this.token) return null;

            $.ajax({
                url: '/fotowebAPI/RequestFullAsset',
                data: { href: href, usertoken: this.token },
                success: (returnObject) => {
                    callback(new AjaxResponse({ responseData: returnObject }));
                },
                // Failing the asset request
                error: (xhr, status, error) => {
                    callback(new AjaxResponse({ responseData: null, xhr: xhr, status: status, error: error }));
                }
            });
        }

        downloadAndSaveImage = (fotowebImageMetadata: any, href: string, currentPageId: number, currentContentLink: string, callback: Function) => {

            var json = JSON.stringify({ metadata: fotowebImageMetadata, href: href, usertoken: this.token, currentPageId: currentPageId, currentContentLink: currentContentLink });

            $.ajax({
                type: 'POST',
                url: '/fotowebAPI/DownloadAndSaveImage',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: json,
                success: (data) => {
                    callback(new AjaxResponse({ responseData: data }));
                },
                // Failing downloading or saving asset
                error: (xhr, status, error) => {
                    callback(new AjaxResponse({ responseData: null, xhr: xhr, status: status, error: error }));
                }
            });
        }
    }

    export class FwApplication {

        // ReSharper disable once InconsistentNaming
        views: Array<View> = [];
        navigationItems: Array<NavigationItem> = [];
        archives: Array<Archive> = [];
        currentView: View;
        loader: $;
        layeredLoader: Loader;
        cropimage: any;
        cropimageRect: ICropRectangle = { x1: 0, y1: 0, x2: 0, y2: 0 };
        loadFotowebImageFile: IFotowebImageMetadata;
        bodywrapper: $;
        acceptButton: $;
        errorModal: $;
        confirmModal: ConfirmModal;
        event: Event = document.createEvent('Event');
        currentContentLink: string;
        searchField: $;
        ownpixelsX: $;
        ownpixelsY: $;
        alttextField: $;

        descriptionField: $;
        editDescriptionField: $;
        editDescriptionBtn: $;
        saveDescriptionBtn: $;
        showDescriptionBox: $;

        uniqeidField: $;
        photographerField: $;
        showPhotographerBox: $;
        consentfield: $;
        element: $;
        currentContext: ICurrentContext;

        constructor(element, currentContext: ICurrentContext) {
            this.element = $(element);
            this.currentContext = currentContext;
            // I do this because tinymce uses an old version of $, so the input element object will fail to run certain functions. 
            // By re- wrapping the element in a $ object in here I ensure that the version of the object is streamlined.
            // element = $(element.get(0));
            // The general loader symbol located in the bottom left corner of the application
            this.loader = this.element.find('.fw-loader');
            this.bodywrapper = this.element.find('.fw__bodywrapper');
            this.layeredLoader = new Loader(this.bodywrapper, '#000000');
            this.layeredLoader.show();
            this.acceptButton = this.element.find('.fw-assetselect__accept');
            this.errorModal = this.element.find('[data-modal=errormodal]');
            this.event.initEvent('imageSelected', true, true);
            this.searchField = this.element.find('.fw__searchfield');

            this.alttextField = this.element.find('.alttext');

            this.descriptionField = this.element.find('[data-description]');
            this.uniqeidField = this.element.find('[data-uniqeid]');
            this.editDescriptionField = this.element.find('[data-editdescription]');
            this.editDescriptionBtn = this.element.find('[data-editdescriptionbtn]');
            this.saveDescriptionBtn = this.element.find('[data-savedescriptionbtn]');
            this.showDescriptionBox = this.element.find('[data-showdescriptionbox]');
            this.ownpixelsX = this.element.find('[data-ownpixelsX]');
            this.ownpixelsY = this.element.find('[data-ownpixelsY]');
            this.photographerField = this.element.find('[data-photographer] p');
            this.showPhotographerBox = this.element.find('[data-photographer] input');
            this.consentfield = this.element.find('[data-consent] p')

            this.errorModal.find('.fw__closebtn').click(() => {
                this.errorModal.removeClass('show');
            });

            this.confirmModal = new ConfirmModal(this.element.find('[data-modal=confirmmodal]'));


            this.element.find('.fw__searchfield').on('focus', (e) => {
                $(document).on('keydown', (k) => {
                    if (k.which == 13) {
                        k.preventDefault();
                    }
                });
                $(document).on('keyup', (k) => {
                    if (k.which == 13) {
                        k.preventDefault();
                        this.element.find('.fw__searchbtn').trigger('click');
                    }
                });
            });

            this.element.find('.fw__searchfield').on('blur', (e) => {
                $(document).off('keydown');
                $(document).off('keyup');
            });

            this.alttextField.on('focus', (e) => {
                $(document).on('keydown', (k) => {
                    if (k.which == 13) {
                        k.preventDefault();
                    }
                });
                $(document).on('keyup', (k) => {
                    if (k.which == 13) {
                        k.preventDefault();
                        this.acceptButton.trigger('click');
                    }
                });
            });
            this.alttextField.on('blur', (e) => {
                $(document).off('keydown');
                $(document).off('keyup');
            });

            this.element.find('.fw__searchbtn').click(() => {
                this.search(this.searchField.val() as string);
            });

            // Model all the different 'Views' of the application
            this.element.find('.fw__main').each((i, e) => {
                this.views.push(new View($(e)));
            });

            // Set currently active 'View', starts with archive
            this.currentView = this.views.find(x => x.viewName === 'archive');

            // Model all 'NavigationItems', i.e. the menu items in the black left menu
            this.element.find('.fw__navpanel a').each((i, e) => {
                this.navigationItems.push(new NavigationItem($(e), this));
            });

            // First we need to authenticate the current user and recieve a user token from the API
            // This user token needs to be submitted in subsequent requests in order to get the correct data back.
            FwApiService.getInstance().getUserToken((token) => {

                if (token === 'Unauthorized') {
                    this.layeredLoader.hide();
                    var p = this.errorModal.find('p');
                    p.html('Din användare har inte rättigheter att ansluta mot Fotoweb');
                    this.errorModal.addClass('show');
                    return;
                }
                else {

                    this.element.trigger('usertokenset');

                    // Next, lets request all the archives so we can populate the 'Arkiv'-view of the application.
                    FwApiService.getInstance().getArchives((archives) => {

                        if (archives) {
                            this.element.find('.fw-archive__wrapper[data-archive]').append(archives);
                            this.element.find('.fw-archive__wrapper[data-archive] .fw-archive').each((i, e) => {
                                this.archives.push(new Archive($(e), this));
                            });
                            this.layeredLoader.hide();
                        }
                    });

                }
            });

            var albumsLoaded = false;
            this.element.find('a[data-view=album]').click(() => {
                if (!albumsLoaded) {
                    this.layeredLoader.show();

                    FwApiService.getInstance().getAlbums((albums) => {

                        this.element.find('.fw-archive__wrapper[data-album]').append(albums);
                        this.element.find('.fw-archive__wrapper[data-album] .fw-archive').each((i, e) => {
                            this.archives.push(new Archive($(e), this));
                        });
                        albumsLoaded = true;
                        this.layeredLoader.hide();
                    });
                }
            });

            let bookMarksLoaded = false;
            this.element.find('a[data-view=bookmarks]').click(() => {
                if (!bookMarksLoaded) {
                    this.layeredLoader.show();

                    FwApiService.getInstance().getBookMarks((bookmarks) => {
                        const bookmarksView = this.views.find(v => v.viewName === 'bookmarks');
                        bookmarksView.element.find('h2').html('Bokmärken');
                        bookmarksView.element.find('.fw-asset__wrapper').append(bookmarks);
                        bookmarksView.element.find('.fw-asset').each((i, e) => {
                            var asset = new Asset($(e), this, false, true);
                        });
                        this.navigateTo('bookmarks');
                        bookMarksLoaded = true;
                        this.layeredLoader.hide();
                    });
                }
            });
        }

        search = (searchTerm: string) => {
            if (searchTerm !== '') {
                this.layeredLoader.show();

                if (!stringStartsWith(searchTerm, '?', 0)) {
                    searchTerm = '?q=' + searchTerm;
                }

                FwApiService.getInstance().search(searchTerm, (searchResult) => {
                    var searchResultView = this.views.find(v => v.viewName === 'search');
                    searchResultView.element.empty();
                    searchResultView.element.append(searchResult);
                    searchResultView.element.find('.fw-asset').each((i, e) => {
                        var asset = new Asset($(e), this, true);
                    });
                    this.navigateTo('search');
                    this.layeredLoader.hide();
                }
                );
            }
        }

        loadSingleAsset = (assetInfoHref: string, fotowebImageFile: IFotowebImageMetadata) => {
            this.layeredLoader.show();


            FwApiService.getInstance().getSingleAsset(assetInfoHref, (response: AjaxResponse) => {

                if (response.statusCode === 404) {
                    this.layeredLoader.hide();
                    var p = this.errorModal.find('p');

                    let h = this.errorModal.find('h2');

                    h.html("Bilden kan inte hittas");

                    let fileName = assetInfoHref.split('/').pop().replace(".info", "");

                    p.html('Optimizely hittar inte bilden ' + fileName + ' i VGR Mediebank. Den kan ha arkiverats av ålder, tagits bort eller flyttats av någon anledning.</br><br/> Om du vill kunna använda bilden behöver du kontakta din förvaltnings medieadministratör och ta reda på vad som hänt. Du kan också använda en annan bild, eller ingen bild alls.');

                    this.errorModal.addClass('show');
                } else if (response.statusCode === 200) {
                    this.navigateTo('assetselect');
                    this.loadFotowebImageFile = fotowebImageFile;
                    var $asset = $(response.responseData);
                    var assetListView = this.views.find(v => v.viewName === 'assetlist');
                    var wrapper = assetListView.element.find('.fw-asset__wrapper');
                    wrapper.append($asset);
                    var domAsset = wrapper.find('.fw-asset').last();
                    var asset = new Asset(domAsset, this);
                    asset.element.trigger('click', true);
                }
            });
        }

        // Function to switch 'View'
        navigateTo = (view: string) => {
            var destination = this.views.find(v => v.viewName === view);
            this.currentView.hide();
            destination.show();
            this.currentView = destination;
        }

        // Function to determine whether or not an element (asset) is visible in the viewport (of the application, not window)
        // Used to request more assets (images) from the API when scrolling down in the application
        isInViewport = (element: $, viewport: $) => {
            var elementTop = element.position().top;
            var elementBottom = elementTop + element.outerHeight();
            return (elementBottom > 0) && (elementTop < viewport.height());
        }

        public authenticateUserIfNot = () => {
            const fwApiService = FwApiService.getInstance();
            const token = fwApiService.token;

            let includePort = window.location.hostname.indexOf("localhost") !== -1;
            const port = includePort ? ":" + window.location.port : "";

            if (!token) {
                const confirm = window.confirm("Du måste autentisera dig mot VGR Mediebank om du vill kunna använda bilder.")
                if (confirm) window.location.href = "https://" + window.location.hostname + port + "/fotoweb/authorize?redirectUri=" + window.location.href;
            }
        }
    }

    class ConfirmModal {
        acceptBtn: $;
        cancelBtn: $;
        heading: $;
        body: $;
        element: $;

        constructor(element) {
            this.acceptBtn = element.find('.accept');
            this.cancelBtn = element.find('.cancel');
            this.heading = element.find('h2');
            this.body = element.find('p');
        }

        setHeading = (heading: string) => {
            this.heading.html(heading);
        }

        setBody = (body: string) => {
            this.body.html(body);
        }

        confirm = (): boolean => {

            return true;
        }
    }

    // Simple model for a 'NavigationItem'
    class NavigationItem {
        element: $;
        app: FwApplication;
        constructor(element: $, app: FwApplication) {
            this.element = element;
            this.app = app;
            this.element.click(() => {
                this.app.navigateTo(this.element.attr('data-view'));
                this.app.navigationItems.forEach((e) => {
                    e.element.removeClass('active');
                });
                this.element.addClass('active');
            });
        }
    }

    // Simple model for a 'View'
    class View {
        viewName: string;
        element: $;
        constructor(element: $) {
            this.element = element;
            this.viewName = this.element.attr('data-view');
        }

        show = () => {
            this.element.addClass('active');
        }

        hide = () => {
            this.element.removeClass('active');
        }
    }

    // Model for an 'Archive'
    class Archive {
        archivedata: string;
        assetList: Array<Asset> = [];
        paginator: $;
        assetListView: View;
        archiveName: string;
        element: $;
        app: FwApplication;
        isSearchResult?: boolean;

        constructor(element: $, app: FwApplication, isSearchResult?: boolean) {
            this.element = element;
            this.app = app;
            this.isSearchResult = isSearchResult;
            // Archivedata contains the URL needed in order to GET this archives' assets (images)
            this.archivedata = this.element.attr('data-archivedata');
            this.assetListView = this.app.views.find(v => v.viewName === 'assetlist');
            this.archiveName = this.element.find('h3').html();

            // Basically clicking on an archive
            this.element.find('.fw-archive__image, .fw-archive__bodywrapper').click(() => {
                this.assetList = [];
                this.getArchiveAssetList();
                // Set the headline for the asset list view to that of the archive name
                this.assetListView.element.find('h2').html(this.archiveName);
                this.app.navigateTo('assetlist');
            });

        }

        getArchiveAssetList = (nextPage?: string) => {
            // Show loader
            this.app.loader.show();
            var wrapper = null;
            if (this.isSearchResult) {
                wrapper = $(this.element.nextAll('.fw-asset__wrapper')[0]);
            } else {
                wrapper = this.assetListView.element.find('.fw-asset__wrapper');
            }

            // Totally empty the asset wrapper if we've clicked an archive
            if (this.assetList.length === 0)
                wrapper.empty();

            // GET a list of assets (images) from the API, either request the root list, or get a paginated list. (Recursive)
            FwApiService.getInstance().getArchiveAssetList(nextPage, this.archivedata, (data) => {

                // Need to wrap the data in a temporary div so we can find it after we've appended it to the DOM
                wrapper.append(`<div id="newdata">${data}</div>`);

                // And now we can find this chunk of data uniquely in the crowd of other assets
                wrapper.find('#newdata .fw-asset').each((i, e) => {
                    // Model dat beautiful ass... et, giggity!
                    this.assetList.push(new Asset($(e), this.app));
                });

                // Now we need to delete this temporary div from the DOM, but keep the content
                wrapper.find('#newdata .fw-asset').unwrap();

                // Hide the loader
                this.app.loader.hide();

                // Remove the paginator from the previous recursion (if any)
                if (this.paginator !== undefined)
                    this.paginator.remove();

                // Set the paginator for this recursion (if any)
                this.paginator = wrapper.find('.fw-paginator');

                // First: do we have a paginator? Second: is the last asset in the view visible in the viewport? If so - load more assets!
                if (this.paginator.length !== 0 && this.app.isInViewport(this.assetList[this.assetList.length - 1].element, this.assetListView.element)) {
                    // Recurse with paginator data
                    this.getArchiveAssetList(this.paginator.attr('data-loading'));
                } else if (this.paginator.length !== 0) {
                    // First lets remove the 'scroll' event listener, because we do not want to recursively set multiple event listeners that do the same thing
                    this.assetListView.element.off('scroll');
                    // Second hook up a fresh new 'scroll' event listener on the asset view
                    this.assetListView.element.scroll(() => {
                        // When scrolling we check if the last asset in the view is visible in the viewport. If so - load more assets!
                        if (this.app.isInViewport(this.assetList[this.assetList.length - 1].element, this.assetListView.element)) {
                            // Remove the scroll listener when we get a hit, otherwise it will trigger a recursive call many times, 
                            // because the scroll event fires very frequently when scrolling.
                            this.assetListView.element.off('scroll');
                            // Finally recurse with paginator data
                            this.getArchiveAssetList(this.paginator.attr('data-loading'));
                        }
                    });
                }
            });
        }
    }

    // Model of an 'Asset' (image)
    class Asset {
        filename: string;
        href: string;
        jpegHref: string;
        fileExtension: string;
        isAcceptableExtension: boolean;
        assetInfoHref: string;
        preview: string;
        description: string;
        uniqeid: string;
        photographer: string;
        consent: string;
        tags: Array<string> = [];
        element: $;
        app: FwApplication;
        isSearchResult?: boolean;
        isBookmark?: boolean;

        constructor(element: $, app: FwApplication, isSearchResult?: boolean, isBookmark?: boolean) {
            this.element = element;
            this.app = app;
            this.isSearchResult = isSearchResult;
            this.filename = this.element.find('.fw-asset__filename').html();
            this.href = this.element.attr('data-href');
            this.jpegHref = this.element.attr('data-jpeg');
            this.preview = this.element.attr('data-preview');
            this.assetInfoHref = this.element.attr('data-assetinfo');
            this.fileExtension = this.filename.substr(this.filename.lastIndexOf('.') + 1);
            this.description = this.element.find('.fw-asset__metadata [data-description]').html();
            var uniqeidHtml = this.element.find('.fw-asset__metadata [data-uniqeid]').html();
            var photographerHtml = this.element.find('.fw-asset__metadata [data-photographer]').html();
            if (photographerHtml != null) {
                this.photographer = photographerHtml.trim();
            }
            if (uniqeidHtml != null) {
                this.uniqeid = uniqeidHtml.trim();
            }
            var consentHtml = this.element.find('.fw-asset__metadata [data-consent]').html();
            if (consentHtml != null) {
                this.consent = consentHtml.trim();
            }


            const acceptableExtensions = ['jpg', 'jpeg', 'jpe', 'ico', 'gif', 'bmp', 'png'];
            this.isAcceptableExtension = (acceptableExtensions.indexOf(this.fileExtension) > -1);

            this.element.find('.fw-asset__metadata [data-tags]').children().each((i, e) => {
                this.tags.push($(e).html());
            });
            this.element.find('.fw-asset__metadata').remove();

            // Clicking the thumbnail of an asset to open it in preview & crop mode (assetselect)
            this.element.click((e, singleAsset?: boolean) => {
                this.app.navigateTo('assetselect');
                this.app.layeredLoader.show();

                var backLink = this.app.currentView.element.find('.fw__back');
                backLink.off('click');
                backLink.click(() => {
                    if (singleAsset) {
                        this.app.navigateTo('archive');
                    } else if (this.isSearchResult) {
                        this.app.navigateTo('search');
                    }
                    else {
                        if(isBookmark){
                            this.app.navigateTo('bookmarks');
                        }
                        else{
                            this.app.navigateTo('assetlist');
                        }
                    }
                });

                this.populateMetaData();
                this.databindRatioPicker();

                if (this.app.cropimage !== undefined) {
                    this.app.cropimage.cropper('destroy');
                }

                this.app.currentView.element.find('h2').html(this.filename);
                this.app.currentView.element.find('[data-uniqeid]').html(this.uniqeid);
                var image = this.app.currentView.element.find('.fw-assetselect__image') as any;

                // We have to get the preview image via a proxy, else we would run into cross-domain issues with the cropping script
                image.attr('src', `/fotowebAPI/GetProxiedImage?href=${this.preview}`);
                var selectedImage = this.app.element.find('.fw-assetselect__image')[0] as HTMLImageElement;
                //var selectedImage = document.querySelector('[data-selectedimage]') as HTMLImageElement;

                // Documentation for the cropper script can be found here: https://github.com/fengyuanchen/cropper
                // Example of the cropper script can be found here: https://fengyuanchen.github.io/cropper/
                this.app.cropimage = image.cropper({
                    aspectRatio: NaN,
                    viewMode: 1,
                    autoCropArea: 1,
                    movable: false,
                    rotatable: false,
                    zoomable: false,
                    scalable: false,
                    crop: (e) => {
                        // I'm setting the coordinates for a rect using percentage values here, because we are cropping on a 'preview-sized' image, 
                        // the original image that we request in the final step is probably larger, and the cropping needs to be the same.
                        this.app.cropimageRect.x1 = Math.round(e.x / (selectedImage.naturalWidth / 100));
                        this.app.cropimageRect.y1 = Math.round(e.y / (selectedImage.naturalHeight / 100));
                        this.app.cropimageRect.x2 = Math.round((e.x + e.width) / (selectedImage.naturalWidth / 100));
                        this.app.cropimageRect.y2 = Math.round((e.y + e.height) / (selectedImage.naturalHeight / 100));
                    },
                    cropend: (e) => {
                        // Cropper frame contains the entire image - ok to set image height/width
                        if (this.app.cropimageRect.x1 === 0 && this.app.cropimageRect.y1 === 0 && this.app.cropimageRect.x2 === 100 && this.app.cropimageRect.y2 === 100) {
                            this.enableSizeInputs();
                        }
                        else {
                            this.disableSizeInputs();
                        }
                    },
                    ready: () => {
                        // If we got some crop data from the server we now apply it to the cropper script
                        if (this.app.loadFotowebImageFile != undefined) {
                            const cropData = JSON.parse(this.app.loadFotowebImageFile.cropData);
                            this.app.cropimage.cropper('setData', cropData);
                            this.app.loadFotowebImageFile = null;

                            //Disable size inputs if there is cropdata
                            if(cropData) {
                                this.disableSizeInputs();
                            }
                        }
                        else {
                            this.enableSizeInputs();
                        }
                        this.databindAcceptButton();
                        this.app.layeredLoader.hide();
                    }
                });


            });
        }

        populateMetaData = () => {
            var showDescription = this.app.showDescriptionBox[0] as HTMLInputElement;
            var showPhotographer = this.app.showPhotographerBox[0] as HTMLInputElement;
            var photgrapherWrapper = this.app.currentView.element.find('[data-photographer]');
            var consentWrapper = this.app.currentView.element.find('[data-consent]');
            showDescription.checked = false;
            showPhotographer.checked = false;

            if (this.photographer == '' || this.photographer == null) {
                photgrapherWrapper.addClass('hidden');
            } else {
                photgrapherWrapper.removeClass('hidden');
                this.app.photographerField.html(this.photographer);
            }

            if (this.consent == '' || this.consent == null) {
                consentWrapper.addClass('hidden');
            }
            else {
                consentWrapper.removeClass('hidden');
                this.app.consentfield.html(this.consent);
            }


            var tagElements = '';
            this.tags.forEach((tag) => {
                tagElements += `<div class="fw-assetselect__tag">${tag}</div>`;
            });
            if (tagElements === '') {
                tagElements = 'Denna bild har inga taggar';
            }
            this.app.currentView.element.find('[data-tags]').html(tagElements);
            if (this.app.loadFotowebImageFile != undefined) {
                this.app.alttextField.val(this.app.loadFotowebImageFile.alttext);
                this.app.descriptionField.html(this.app.loadFotowebImageFile.description);
                this.app.editDescriptionField.val(this.app.loadFotowebImageFile.description);
                if (this.app.loadFotowebImageFile.showDescription)
                    showDescription.checked = true;
                if (this.app.loadFotowebImageFile.showPhotographer)
                    showPhotographer.checked = true;
            } else {
                this.app.alttextField.val('');
                this.app.descriptionField.html(this.description);
                this.app.editDescriptionField.val(this.description);
            }
            this.dataBindDescription();
        }

        dataBindDescription = () => {
            this.app.editDescriptionBtn.off('click');
            this.app.editDescriptionBtn.click((e) => {
                e.preventDefault();
                this.app.descriptionField.addClass('hidden');
                this.app.editDescriptionField.removeClass('hidden');
                this.app.saveDescriptionBtn.removeClass('hidden');
                this.app.editDescriptionBtn.addClass('hidden');
                this.app.editDescriptionField.focus();
            });
            this.app.saveDescriptionBtn.off('click');
            this.app.saveDescriptionBtn.click((e) => {
                e.preventDefault();
                this.app.descriptionField.html(this.app.editDescriptionField.val() as string);
                this.app.descriptionField.removeClass('hidden');
                this.app.editDescriptionField.addClass('hidden');
                this.app.saveDescriptionBtn.addClass('hidden');
                this.app.editDescriptionBtn.removeClass('hidden');
            });
        }

        databindRatioPicker = () => {
            const self = this;
            var select = this.app.currentView.element.find('.fw-assetselect__ratio');
            select.val('0/0');
            select.off('change');
            select.on('change', (e) => {
                var ratio = $(e.currentTarget).val() as string;
                var ratioParts = ratio.split('/');
                var aspectRatio = parseInt(ratioParts[0]) / parseInt(ratioParts[1]);
                this.app.cropimage.cropper('setAspectRatio', aspectRatio);
                
                //Resizing will only be done if there is no cropdata so disable size inputs for all aspect ratios except 0/0
                if(ratio !== '0/0') {
                    self.disableSizeInputs();
                } else {
                    self.enableSizeInputs();
                }
            });
        }

        disableSizeInputs = () => {
            this.app.ownpixelsX.attr('disabled', '');
            this.app.ownpixelsY.attr('disabled', '');
        }

        enableSizeInputs = () => {
            this.app.ownpixelsX.removeAttr('disabled');
            this.app.ownpixelsY.removeAttr('disabled');
        }

        validateInput = (): boolean => {
            var elements = this.app.currentView.element.find('[required]');
            var isValid = true;
            elements.each((i, e) => {
                var element = $(e);
                var errorMsg = element.siblings('.errormsg').first();
                errorMsg.addClass('hidden');
                if (element.val() === '') {
                    isValid = false;
                    errorMsg.removeClass('hidden');
                }

            });
            var altTextField = this.app.currentView.element.find('.alttext');
            if (altTextField.val() === '') {
                isValid = confirm('Är du säker på att du vill fortsätta utan att ange en alt-text? Alt-texten är viktig för tillgängligheten på webbplatsen.');
            }
            return isValid;
        }

        databindAcceptButton = () => {
            this.app.acceptButton.off('click');
            this.app.acceptButton.click(() => {
                if (this.validateInput()) {
                    this.app.layeredLoader.show();

                    var loadingText = this.app.element.find('.fw-loader--layered .fw-loader__text');
                    var progressTextWrapper = loadingText.find('.progresstextwrapper');
                    if (progressTextWrapper.length > 0) {
                        progressTextWrapper.find('.fw-loader__progresstext').each((i, e) => {
                            $(e).removeClass('done');
                        });
                    } else {
                        loadingText.append('<div class="progresstextwrapper"></div>');
                        progressTextWrapper = this.app.element.find('.fw-loader__text > .progresstextwrapper');
                        progressTextWrapper.append(loadlayerTextElement('Begär källbild från Fotoweb'));
                        progressTextWrapper.append(loadlayerTextElement('Hämtar källbild från Fotoweb'));
                        progressTextWrapper.append(loadlayerTextElement('Kontrollerar beskärningslogik'));
                        progressTextWrapper.append(loadlayerTextElement('Sparar bilden i EPiServer'));
                    }
                    if (this.isAcceptableExtension) {
                        // First lets request the full asset URL from the API
                        FwApiService.getInstance().requestFullAsset(this.href, (response: AjaxResponse) => {
                            // Success
                            if (!response.error) {
                                var json = JSON.parse(response.responseData);
                                if (json.status === 'OK') {
                                    this.downloadAndSaveImage(json.data, progressTextWrapper, loadingText);
                                } else {
                                    this.app.layeredLoader.hide();
                                    var p = this.app.errorModal.find('p');
                                    p.html('Servern svarade med följande fel: ' + json.data);
                                    this.app.errorModal.addClass('show');
                                    progressTextWrapper.remove();
                                }
                                // Error
                            } else {
                                this.app.layeredLoader.hide();
                                var p = this.app.errorModal.find('p');
                                p.html('Servern svarade med följande fel: ' + response.error);
                                this.app.errorModal.addClass('show');
                                progressTextWrapper.remove();
                            }
                        });
                    } else {
                        this.downloadAndSaveImage(this.jpegHref, progressTextWrapper, loadingText);
                    }
                }

            });
        }

        downloadAndSaveImage = (data: string, progressTextWrapper: $, loadingText: $) => {
            if (data === '500') {
                this.app.layeredLoader.hide();
                var p = this.app.errorModal.find('p');
                p.html('Det gick inte att begära bilden från Fotowebs server. Felet som servern svarade med heter: 500, Internal Server Error.<br/><br/> Jaha vad betyder det då? Mer specifik information ges inte, någonting i programkoden på Fotowebs server stötte på problem och kraschade. Kontakta IT om detta problem kvarstår.');
                this.app.errorModal.addClass('show');
                progressTextWrapper.remove();
                return;
            }

            $(loadingText.find('.fw-loader__progresstext')).first().addClass('done');

            var cropRect = this.app.cropimageRect;
            cropRect.cropBoxData = JSON.stringify(this.app.cropimage.cropper('getData'));

            //// Do we NOT have a crop?
            if (cropRect.x1 === 0 && cropRect.y1 === 0 && cropRect.x2 === 100 && cropRect.y2 === 100) {
                cropRect = null;
            }

            var fotowebImageMetadata = {
                Alttext: this.app.alttextField.val(),
                Description: this.app.editDescriptionField.val(),
                uniqeid: this.app.uniqeidField.html(),
                ShowDescription: this.app.showDescriptionBox.is(':checked'),
                Photographer: this.app.photographerField.html(),
                ShowPhotographer: this.app.showPhotographerBox.is(':checked'),
                CropData: cropRect,
                Height: this.app.ownpixelsY.val(),
                Width: this.app.ownpixelsX.val()

            };

            var currentPageId = parseInt(this.app.currentContext.id.split('_')[0]);

            // Then lets download the full asset from the Fotoweb server and save it locally
            FwApiService.getInstance().downloadAndSaveImage(fotowebImageMetadata, data, currentPageId, this.app.currentContentLink, (response: AjaxResponse) => {
                // Success
                if (!response.error && response.status !== 'error' && response.responseData.errorMessage == null) {
                    var success = true;
                    // We might fail even if we get a return
                    if (response.responseData.statusCode !== 200) {
                        success = false;
                        var errorMessage = '';

                        switch (response.responseData.statusCode) {
                            case 202:
                                errorMessage = 'Error 202: Fotowebs Rendition Request Service svarade med att den inte är redo att överlämna bilden i fråga. Testa igen om en minut, om problemet kvarstår vänligen kontakta VGR IT.';
                                break;
                            case 410:
                                errorMessage = 'Error 410: Ett internt serverfel inträffade på Fotowebs server, eller så har dina rättigheter till bilden förändrats/löpt ut precis i detta skede. Testa att ladda om sidan.';
                                break;
                            default:
                                errorMessage = `Error ${response.responseData.statusCode}: Servern svarade med: ${response.responseData.statusText}`;
                        }

                        this.app.layeredLoader.hide();
                        var p = this.app.errorModal.find('p');
                        p.html(errorMessage);
                        this.app.errorModal.addClass('show');
                    }
                    if (success) {
                        var progressElements = loadingText.find('.fw-loader__progresstext:not(:first-of-type)');
                        var i = 0;

                        var timedElements = (element) => {
                            setTimeout(() => {
                                $(element).addClass('done');
                                i++;
                                if (i < progressElements.length) {
                                    timedElements(progressElements[i]);
                                } else {
                                    setTimeout(() => {
                                        this.app.layeredLoader.hide();
                                        progressTextWrapper.remove();
                                        // This event will be listened to in FotowebIntegrationProperty.js and will save the property to EPiServer.
                                        this.app.element.trigger('imageSelected', [response.responseData.absoluteUrl, response.responseData.imageReference, response.responseData.thumbnail, this.assetInfoHref, fotowebImageMetadata]);
                                    }, 10);
                                }
                            }, 100);
                        }
                        timedElements(progressElements[i]);

                    }
                    // Error
                } else {
                    var errorMessage = '';
                    if (response.responseData.errorMessage != null)
                        errorMessage = response.responseData.errorMessage;
                    else
                        errorMessage = response.error;
                    this.app.layeredLoader.hide();
                    var p = this.app.errorModal.find('p');
                    p.html('Servern svarade med följande fel: ' + errorMessage);
                    this.app.errorModal.addClass('show');
                    progressTextWrapper.remove();
                }
            });
        }

    }

    class Loader {
        loaderElement: $;
        constructor(target: $<HTMLElement>, bgcolor?: string) {
            this.loaderElement = $('<div class="fw-loader--layered hidden"><div class="fw-loader__symbol"><div class="square sqr0"></div><div class="square sqr1"></div><div class="square sqr2"></div><div class="square sqr3"></div><div class="square sqr4"></div><div class="square sqr5"></div><div class="square sqr6"></div></div><div class="fw-loader__text">Laddar</div></div>');
            target.css({ position: 'relative' });
            target.prepend(this.loaderElement);
            if (bgcolor != null) {
                var rgb = hexToRgb(bgcolor);
                this.loaderElement.css({ background: `rgba(${rgb.r},${rgb.g},${rgb.b}, 0.8)` });
            }
            this.loaderElement.hide();
        }

        show = () => {
            this.loaderElement.fadeIn();
        }

        hide = () => {
            this.loaderElement.fadeOut();
        }

        destroy = () => {
            this.loaderElement.remove();
        }
    }

    function loadlayerTextElement(text: string) {
        return `<div class='fw-loader__progresstext'>${text}<svg fill="#FFFFFF" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg></div>`;
    }

    function hexToRgb(hex) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, (m, r, g, b) => (r + r + g + g + b + b));

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
}